
export const GET_SECCIONES_PAGINAS = "GET_SECCIONES_PAGINAS"
export const GET_SECCIONES_PAGINAS_SUCCESS = "GET_SECCIONES_PAGINAS_SUCCESS"
export const GET_SECCIONES_PAGINAS_FAIL = "GET_SECCIONES_PAGINAS_FAIL"

